<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text">
                        <p class="main">Pay Bills</p>
                        <!--<p class="sub">From me to me</p>-->
                        <p class="sub">{{pageSub}}</p>
                    </div>
                </div>
            </div>

            <div v-if="stage === 1">
                <div class="option-component">
                    <div class="options">
                        <div class="alert-box">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                    <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                        {{alert.message}}
                                    </ui-alert>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(3, 'Cable Tv Bills')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M481.1 27.9H30.9C13.9 27.9 0 41.8 0 58.8v310.8c0 17 13.9 30.9 30.9 30.9h154.3v22.5c0 20.6-16.8 37.4-37.4 37.4h-34c-6.5 0-11.8 5.3-11.8 11.8 0 6.5 5.3 11.8 11.8 11.8h284.4c6.5 0 11.8-5.3 11.8-11.8 0-6.5-5.3-11.8-11.8-11.8h-34c-20.6 0-37.4-16.8-37.4-37.4v-22.5h154.3c17 0 30.9-13.9 30.9-30.9V58.8C512 41.8 498.1 27.9 481.1 27.9zM195.9 460.5c8-10.3 12.9-23.3 12.9-37.4v-22.5h94.4v22.5c0 14.1 4.8 27.1 12.9 37.4H195.9zM488.4 369.7c0 4-3.3 7.3-7.3 7.3H30.9c-4 0-7.3-3.3-7.3-7.3v-62h464.8V369.7zM488.4 284H23.6V58.8c0-4 3.3-7.3 7.3-7.3h450.2c4 0 7.3 3.3 7.3 7.3V284z"></path>
                                        <circle cx="256" cy="342.3" r="12.7"></circle>
                                        <path d="M276.2 109.3c-4.6-4.6-12.1-4.6-16.7 0l-83.4 83.4c-4.6 4.6-4.6 12.1 0 16.7 2.3 2.3 5.3 3.5 8.3 3.5 3 0 6-1.2 8.3-3.5l83.4-83.4C280.8 121.3 280.8 113.9 276.2 109.3z"></path>
                                        <path d="M325.7 157.6c-4.6-4.6-12.1-4.6-16.7 0l-33.2 33.2c-4.6 4.6-4.6 12.1 0 16.7 2.3 2.3 5.3 3.5 8.3 3.5 3 0 6-1.2 8.3-3.5l33.2-33.2C330.3 169.7 330.3 162.2 325.7 157.6z"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">Cable Tv Bills</p>
                                    <p class="sub">Dstv, GoTv, tickets etc.</p>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(1, 'Flight & Hotel')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 372.1 372.1">
                                        <path d="M365.4 35.3c-4.1-2.6-8.7-3.6-14.3-3.1 -9.7 1.5-17.9 5.1-25.6 10.8 -6.7 5.1-14.3 11.3-23 18.4 -4.1 3.6-8.2 7.2-12.3 10.8 -2.6 2.6-5.1 4.6-7.7 7.2 -2.6 2-4.6 3.1-7.7 2.6 -1.5-0.5-3.6-1-5.6-1.5l-95.7-35.8c-3.1-1-6.1-2-9.7-3.1 -7.2-2-12.3 0-15.4 2.6 -5.6 4.1-10.2 9.2-13.3 14.8 -3.6 5.6-2.6 11.8 2.6 16.4 2 2 4.1 3.6 5.6 4.6 17.4 12.3 35.3 24.1 52.7 36.4 6.7 4.6 12.8 8.7 17.4 14.3 1 1.5 2 2.6 3.1 4.1l-33.3 31.7c-3.6 3.6-7.2 6.7-10.8 10.2 -0.5 0-1-0.5-1.5-0.5l-5.6-2.6c-4.6-2-8.7-4.6-13.3-6.7 -5.6-2.6-11.8-2-16.4 2 -2.6 2-5.1 4.6-7.7 7.2 -4.6 4.6-5.1 10.2-1 15.4 1 1.5 2 2.6 3.1 3.6l9.7 12.3c11.3 14.8 23 29.7 34.8 44 1.5 2 3.1 3.6 5.1 4.6 2 1 6.1 3.6 11.3 2 6.1-2 10.8-6.1 12.8-12.3 2-5.1 2.6-10.8 0.5-16.9l-1-4.6c-1-4.1-2-8.2-3.1-12.3 13.8-10.8 27.6-21 41-31.7l6.7-5.1 1.5 2.6c3.6 5.6 6.7 11.3 8.7 17.4l23.6 60.4c1.5 3.6 2.6 7.2 4.1 10.2 2.6 5.6 6.7 8.7 11.8 8.7 2 0 4.1-0.5 6.1-1.5 1.5-0.5 3.1-1 4.1-2 8.2-4.1 13.3-9.7 15.4-17.4 1.5-6.1 1-11.8 0.5-15.9l-12.3-89.6c-1-7.2-2-14.8-3.1-22 -0.5-3.6 0.5-5.6 3.1-7.7l10.8-9.2c8.7-7.2 16.9-14.3 25.6-21.5 7.2-6.1 11.8-11.8 15.9-17.9 3.1-4.6 6.1-10.2 7.7-16.4C373.6 46.6 371.1 39.4 365.4 35.3zM361.3 51.2c-1.5 5.1-4.1 9.7-6.7 13.8 -3.1 5.1-7.7 10.2-13.8 15.4 -8.2 7.2-16.9 14.3-25.6 21.5l-10.2 8.7c-5.6 4.1-8.2 10.2-7.2 17.4 1 7.2 2 14.3 3.1 22l12.3 89.6c0.5 5.1 0.5 8.7-0.5 11.8 -1.5 4.6-4.6 8.2-9.7 10.8 -1 0.5-2 1-3.6 1.5 -3.1 1-4.1 0.5-5.1-2 -1.5-3.1-2.6-6.7-4.1-10.2l-22.5-60.4c-2.6-6.7-6.1-12.8-9.7-18.9l-3.1-5.1 -4.6-6.7 -15.9 11.8c-14.3 10.8-28.7 22-42.5 32.8 -3.6 2.6-3.1 5.6-2.6 7.7 1 4.6 2.6 9.2 3.6 13.8l1 4.6c1 4.1 1 7.7-0.5 10.8 -1.5 3.1-3.6 5.1-7.2 6.1 0 0-1 0-2.6-1 -1-0.5-2-1.5-2.6-2.6 -11.8-14.8-23-29.2-34.3-44l-9.7-12.3c-1-1-1.5-2-2.6-3.6 -0.5-0.5-0.5-1-0.5-1s0.5-0.5 1-1c2-2 4.6-4.6 6.7-6.1 1.5-1.5 3.6-1.5 5.6-0.5 4.6 2 8.7 4.1 13.3 6.7l5.6 2.6c1 0.5 2 1 3.1 1.5 2.6 1.5 5.6 1 8.2-1 4.1-4.1 8.2-7.7 12.3-11.8l35.3-33.3 4.1-4.1 -2.6-3.6c-0.5-1-1-1.5-1.5-2.6 -1.5-2-2.6-4.1-4.1-5.6 -5.6-6.7-12.3-11.8-19.5-16.4 -17.4-11.8-35.3-24.1-52.7-36.4 -1.5-1-3.1-2-4.6-3.6 -1.5-1.5-1.5-2-0.5-3.1 2.6-4.6 6.7-8.7 11.3-12.3 1-1 2.6-1.5 6.1-0.5 3.6 1 6.7 2 9.2 3.1l95.7 35.8c2.6 1 5.1 1.5 7.2 2 5.6 1 11.3-0.5 15.9-4.6 2.6-2.6 5.1-4.6 7.7-7.2 4.1-3.6 8.2-7.2 12.3-10.8 8.7-7.2 15.9-13.3 22.5-18.4 6.1-4.6 13.3-7.7 21-8.7 2.6-0.5 4.6 0 6.7 1C361.3 45 362.4 48.1 361.3 51.2z"></path>
                                        <path d="M136.1 228.8c-1.5-2-5.1-2.6-7.2-1L1.9 324.6c-2 1.5-2.6 5.1-1 7.2 1 1.5 2.6 2 4.1 2 1 0 2-0.5 3.1-1l127-96.8C137.6 234.5 137.6 231.4 136.1 228.8z"></path>
                                        <path d="M153 252.9c-2-2-5.1-2.6-7.7-1L68 311.3c-2 1.5-2.6 5.1-1 7.2 1 1.5 2.6 2 4.1 2 1 0 2-0.5 3.1-1l77.8-59.4C154 258.5 154.5 255 153 252.9z"></path>
                                        <path d="M61.8 322c-1.5-2-5.1-2.6-7.2-1l-12.8 9.7c-2 1.5-2.6 5.1-1 7.2 1 1.5 2.6 2 4.1 2 1 0 2-0.5 3.1-1l12.8-9.7C62.8 327.7 63.4 324.1 61.8 322z"></path>
                                        <path d="M44.9 264.7c-1.5-2-5.1-2.6-7.2-1l-12.8 9.7c-2 1.5-2.6 5.1-1 7.2 1 1.5 2.6 2 4.1 2 1 0 2-0.5 3.1-1l12.8-9.7C45.9 270.3 46.5 266.7 44.9 264.7z"></path>
                                        <path d="M119.2 208.9c-1.5-2-5.1-2.6-7.2-1l-60.9 46.1c-2 1.5-2.6 5.1-1 7.2 1 1 2.6 2 4.1 2 1 0 2-0.5 3.1-1l60.9-46.1C120.2 214.5 120.7 210.9 119.2 208.9z"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">Flight & Hotel</p>
                                    <p class="sub">Wakanow, Air Peace, Emirates, etc.</p>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(7, 'Government Payments')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -29 447.00118 447">
                                        <path d="m399.5 171.289062h-14.652344l-128.835937-120.539062c2.300781-4.761719 3.492187-9.984375 3.488281-15.273438-.011719-19.605468-15.917969-35.4882808-35.523438-35.476562-19.605468.0117188-35.488281 15.917969-35.476562 35.523438-.003906 5.273437 1.1875 10.476562 3.488281 15.21875l-128.835937 120.546874h-14.652344c-26.46875 0-48.5 21.78125-48.5 48.25v121c0 26.46875 22.03125 47.75 48.5 47.75h351c12.648438.023438 24.78125-5.007812 33.703125-13.976562 8.917969-8.964844 13.886719-21.125 13.796875-33.773438v-121c0-26.46875-21.03125-48.25-47.5-48.25zm-175.5-155.25c10.769531 0 19.5 8.730469 19.5 19.5 0 10.769532-8.730469 19.5-19.5 19.5s-19.5-8.730468-19.5-19.5c.011719-10.765624 8.734375-19.488281 19.5-19.5zm-21.972656 47.230469c12.84375 10.289063 31.113281 10.277344 43.945312-.03125l115.464844 108.050781h-274.875zm228.972656 277.019531c0 17.671876-14.328125 32-32 32h-351c-17.671875 0-32-14.328124-32-32v-121c0-17.671874 14.328125-32 32-32h351c17.671875 0 32 14.328126 32 32zm0 0"></path>
                                        <path d="m179.800781 247.289062h-43.199219c-3.300781 0-4.703124 3.601563-4.703124 6.902344 0 3.796875 1.703124 7.097656 4.703124 7.097656h13.398438v53.910157c0 3.199219 4.101562 4.800781 8 4.800781s8-1.601562 8-4.800781v-53.910157h13.800781c3 0 4.699219-3.300781 4.699219-7.097656 0-3.300781-1.398438-6.902344-4.699219-6.902344zm0 0"></path>
                                        <path d="m228.601562 251.496094c-1.101562-3.5-5.601562-5.203125-10.203124-5.203125-4.597657 0-9.097657 1.703125-10.199219 5.203125l-18.597657 61c-.109374.355468-.175781.726562-.203124 1.097656 0 3.699219 5.703124 6.402344 10 6.402344 2.5 0 4.5-.957032 5.101562-3.054688l3.398438-12.652344h21.101562l3.398438 12.65625c.601562 2.097657 2.601562 2.976563 5.101562 2.976563 4.300781 0 10-2.660156 10-6.359375-.027344-.367188-.09375-.730469-.199219-1.082031zm-17.5 40.792968 7.296876-26.800781 7.300781 26.800781zm0 0"></path>
                                        <path d="m297.898438 283.398438 16.601562-26.601563c.628906-.914063.976562-1.992187 1-3.101563 0-4.199218-5.699219-7.398437-10.101562-7.398437-1.945313-.15625-3.796876.867187-4.699219 2.601563l-13.300781 23.199218-13.296876-23.199218c-.90625-1.734376-2.753906-2.757813-4.703124-2.601563-4.398438 0-10.097657 3.199219-10.097657 7.398437.019531 1.109376.367188 2.1875 1 3.101563l16.597657 26.601563-17.296876 26.699218c-.554687.832032-.867187 1.800782-.902343 2.800782 0 4.296874 6.101562 7.699218 10.402343 7.699218 1.425782.132813 2.820313-.472656 3.699219-1.601562l14.597657-24.800782 14.601562 24.800782c.601562 1.101562 2.101562 1.601562 3.699219 1.601562 4.300781 0 10.402343-3.402344 10.402343-7.699218-.039062-1-.347656-1.96875-.902343-2.800782zm0 0"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">Government Payments</p>
                                    <p class="sub">FIRS, Land Use Charge, etc.</p>
                                </div>
                            </div>


                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(4, 'Internet Services')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 59">
                                        <path d="M10.4 1.7c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0c-11.3 11.3-11.3 29.7 0 41C9.2 41.5 9.4 41.6 9.7 41.6s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4C-0.1 29.4-0.1 12.2 10.4 1.7z"></path>
                                        <path d="M50 0.3c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4c5.1 5.1 7.9 11.9 7.9 19.1S53.7 34.8 48.6 39.9c-0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c5.5-5.5 8.5-12.8 8.5-20.5S55.5 5.8 50 0.3z"></path>
                                        <path d="M14.7 5.9c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0c-9 9-9 23.6 0 32.5 0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4C6.5 27.5 6.5 14.1 14.7 5.9z"></path>
                                        <path d="M45.8 4.5c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4c8.2 8.2 8.2 21.5 0 29.7 -0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3C54.7 28.1 54.7 13.5 45.8 4.5z"></path>
                                        <path d="M18.9 8.8c-0.4-0.4-1-0.4-1.4 0 -3.2 3.2-5 7.5-5 12s1.8 8.8 5 12c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4 -5.8-5.8-5.8-15.4 0-21.2C19.3 9.8 19.3 9.2 18.9 8.8z"></path>
                                        <path d="M41.5 8.8c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4c5.8 5.8 5.8 15.4 0 21.2 -0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c3.2-3.2 5-7.5 5-12S44.7 12 41.5 8.8z"></path>
                                        <path d="M29.5 14c-3.9 0-7 3.1-7 7 0 3.5 2.6 6.4 6 6.9V58c0 0.6 0.4 1 1 1s1-0.4 1-1V27.9c3.4-0.5 6-3.4 6-6.9C36.5 17.1 33.4 14 29.5 14zM29.5 26c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S32.3 26 29.5 26z"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">Internet Services</p>
                                    <p class="sub">Swift, Spectranet, Smile, etc.</p>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(8, 'School Payments')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511 511">
                                        <path d="M503.5 476H487V267h16.5c2.7 0 5.3-1.5 6.6-3.9 1.3-2.4 1.2-5.3-0.2-7.6l-56-88c-1.4-2.2-3.8-3.5-6.3-3.5H298.6L263 128.4V99h72.5c2.8 0 5.3-1.5 6.6-4 1.3-2.4 1.2-5.4-0.4-7.7L328.5 67.5l13.2-19.8c1.5-2.3 1.7-5.3 0.4-7.7C340.8 37.5 338.3 36 335.5 36H263v-8.5c0-4.1-3.4-7.5-7.5-7.5s-7.5 3.4-7.5 7.5v100.9L212.4 164H63.5c-2.6 0-5 1.3-6.3 3.5l-56 88c-1.5 2.3-1.6 5.2-0.2 7.6C2.2 265.5 4.8 267 7.5 267H24v209H7.5c-4.1 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5h496c4.1 0 7.5-3.4 7.5-7.5S507.6 476 503.5 476zM443.4 179l46.5 73H386.6l-73-73H443.4zM321.5 51l-8.2 12.3c-1.7 2.5-1.7 5.8 0 8.3L321.5 84H263V51H321.5zM67.6 179h129.8l-73 73H21.2L67.6 179zM39 267h88.5c0.2 0 0.5 0 0.7 0 0.1 0 0.2 0 0.3 0 0.1 0 0.3 0 0.4-0.1 0.1 0 0.2-0.1 0.4-0.1 0.1 0 0.2-0.1 0.4-0.1 0.1 0 0.2-0.1 0.3-0.1 0.1 0 0.2-0.1 0.3-0.1 0.1 0 0.2-0.1 0.3-0.1 0.1-0.1 0.2-0.1 0.3-0.2 0.1-0.1 0.2-0.1 0.3-0.2 0.1-0.1 0.2-0.1 0.3-0.2 0.1-0.1 0.2-0.2 0.3-0.2 0.1-0.1 0.2-0.1 0.3-0.2 0.2-0.2 0.4-0.3 0.6-0.5L255.5 142.1l122.7 122.7c0.2 0.2 0.4 0.3 0.6 0.5 0.1 0.1 0.2 0.1 0.3 0.2 0.1 0.1 0.2 0.2 0.3 0.2 0.1 0.1 0.2 0.1 0.3 0.2 0.1 0.1 0.2 0.1 0.3 0.2 0.1 0.1 0.2 0.1 0.3 0.2 0.1 0.1 0.2 0.1 0.3 0.2 0.1 0 0.2 0.1 0.3 0.1 0.1 0 0.2 0.1 0.4 0.1 0.1 0 0.2 0.1 0.3 0.1 0.1 0 0.2 0.1 0.4 0.1 0.1 0 0.3 0 0.4 0.1 0.1 0 0.2 0 0.3 0 0.2 0 0.5 0 0.7 0H472v209H311V371.5c0-13-10.5-23.5-23.5-23.5h-64c-13 0-23.5 10.5-23.5 23.5V476H39V267zM296 380h-81v-8.5c0-4.7 3.8-8.5 8.5-8.5h64c4.7 0 8.5 3.8 8.5 8.5V380zM215 395h33v81h-33V395zM263 395h33v81h-33V395z"></path>
                                        <path d="M255.5 323c30.6 0 55.5-24.9 55.5-55.5S286.1 212 255.5 212 200 236.9 200 267.5 224.9 323 255.5 323zM255.5 227c22.3 0 40.5 18.2 40.5 40.5S277.8 308 255.5 308 215 289.8 215 267.5 233.2 227 255.5 227z"></path>
                                        <path d="M255.5 275c4.1 0 7.5-3.4 7.5-7.5v-24c0-4.1-3.4-7.5-7.5-7.5s-7.5 3.4-7.5 7.5V260h-16.5c-4.1 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5H255.5z"></path>
                                        <path d="M175.5 388h-40c-4.1 0-7.5 3.4-7.5 7.5v48c0 4.1 3.4 7.5 7.5 7.5h40c4.1 0 7.5-3.4 7.5-7.5v-48C183 391.4 179.6 388 175.5 388zM168 403v9h-25v-9H168zM143 436v-9h25v9H143z"></path>
                                        <path d="M103.5 388h-40c-4.1 0-7.5 3.4-7.5 7.5v48c0 4.1 3.4 7.5 7.5 7.5h40c4.1 0 7.5-3.4 7.5-7.5v-48C111 391.4 107.6 388 103.5 388zM96 403v9H71v-9H96zM71 436v-9h25v9H71z"></path>
                                        <path d="M173 292h-35c-5.5 0-10 4.5-10 10v53.5c0 4.1 3.4 7.5 7.5 7.5h40c4.1 0 7.5-3.4 7.5-7.5V302C183 296.5 178.5 292 173 292zM168 307v17h-25v-17H168zM143 348v-9h25v9H143z"></path>
                                        <path d="M101 292H66c-5.5 0-10 4.5-10 10v53.5c0 4.1 3.4 7.5 7.5 7.5h40c4.1 0 7.5-3.4 7.5-7.5V302C111 296.5 106.5 292 101 292zM96 307v17H71v-17H96zM71 348v-9h25v9H71z"></path>
                                        <path d="M407.5 451h40c4.1 0 7.5-3.4 7.5-7.5v-48c0-4.1-3.4-7.5-7.5-7.5h-40c-4.1 0-7.5 3.4-7.5 7.5v48C400 447.6 403.4 451 407.5 451zM415 436v-9h25v9H415zM440 403v9h-25v-9H440z"></path>
                                        <path d="M335.5 451h40c4.1 0 7.5-3.4 7.5-7.5v-48c0-4.1-3.4-7.5-7.5-7.5h-40c-4.1 0-7.5 3.4-7.5 7.5v48C328 447.6 331.4 451 335.5 451zM343 436v-9h25v9H343zM368 403v9h-25v-9H368z"></path>
                                        <path d="M407.5 363h40c4.1 0 7.5-3.4 7.5-7.5V302c0-5.5-4.5-10-10-10h-35c-5.5 0-10 4.5-10 10v53.5C400 359.6 403.4 363 407.5 363zM415 348v-9h25v9H415zM440 307v17h-25v-17H440z"></path>
                                        <path d="M335.5 363h40c4.1 0 7.5-3.4 7.5-7.5V302c0-5.5-4.5-10-10-10h-35c-5.5 0-10 4.5-10 10v53.5C328 359.6 331.4 363 335.5 363zM343 348v-9h25v9H343zM368 307v17h-25v-17H368z"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">School Payments</p>
                                    <p class="sub">Adeleke, Corona, Laspotech, etc.</p>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(6, 'Utility Bills')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.2 512.2">
                                        <path d="M489.1 188.8L292.8 14.7c-20.5-19.6-52.9-19.6-73.4 0l-65.7 59.7v-23h8.5c5.1 0 8.5-3.4 8.5-8.5V8.7c0-5.1-3.4-8.5-8.5-8.5H59.8c-5.1 0-8.5 3.4-8.5 8.5V42.9c0 5.1 3.4 8.5 8.5 8.5h8.5v98.1L23.1 188.8c-6 6-7.7 13.7-5.1 21.3 2.6 6.8 10.2 11.9 17.9 11.9h32.4v238.9H59.8c-5.1 0-8.5 3.4-8.5 8.5v34.1c0 5.1 3.4 8.5 8.5 8.5h392.5c4.3 0 8.5-3.4 8.5-9.4v-34.1c0-2.6-0.9-4.3-2.6-6 -1.7-1.7-3.4-2.6-6-2.6h-8.5V221.2h32.4c8.5 0 15.4-4.3 17.9-11.9C496.7 202.5 495 193.9 489.1 188.8zM478 204.2c-0.9 0.9-1.7 0.9-1.7 0.9h-41c-5.1 0-8.5 3.4-8.5 8.5v256c0 5.1 3.4 8.5 8.5 8.5h8.5v17.1H68.4V478.1h8.5c5.1 0 8.5-3.4 8.5-8.5v-256c0-5.1-3.4-8.5-8.5-8.5h-41c-0.9 0-1.7 0-1.7-0.9s0-1.7 0.9-2.6l47.8-41c1.7-1.7 2.6-4.3 2.6-6.8V42.9c0-5.1-3.4-8.5-8.5-8.5h-8.5V17.3h85.3v17.1h-8.5c-5.1 0-8.5 3.4-8.5 8.5v51.2c0 3.4 1.7 6.8 5.1 9.4 3.4 0.9 6.8 0.9 9.4-1.7l80.2-73.4c13.7-13.7 35-13.7 49.5 0l196.3 174.1C478 202.5 478.8 203.3 478 204.2z"></path>
                                        <path d="M307.3 239.1h-34.1v-34.1h25.6c5.1 0 8.5-3.4 8.5-8.5s-3.4-8.5-8.5-8.5h-68.3c-5.1 0-8.5 3.4-8.5 8.5s3.4 8.5 8.5 8.5h25.6v34.1H145.2c-5.1 0-8.5 3.4-8.5 8.5v51.2c0 5.1 3.4 8.5 8.5 8.5H295.4c1.7 0 3.4 1.7 3.4 3.4v47.8c0 5.1 3.4 8.5 8.5 8.5h51.2c5.1 0 8.5-3.4 8.5-8.5V298.9C367 265.6 340.6 239.1 307.3 239.1zM350 350.1H315.8v-39.3c0-11.1-9.4-20.5-20.5-20.5H153.7v-34.1h153.6c23.9 0 42.7 18.8 42.7 42.7V350.1z"></path>
                                        <path d="M338.9 386.8c-3.4-3.4-8.5-3.4-11.9 0l-17.1 17.1c-12.8 12.8-12.8 33.3 0 46.1 6 6 14.5 9.4 23 9.4s17.1-2.6 23-9.4c12.8-12.8 12.8-33.3 0-46.1L338.9 386.8zM344 438c-6 6-16.2 6-22.2 0s-6-16.2 0-22.2l11.1-11.1L344 415.8C350 421.8 350 432 344 438z"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">Utility Bills</p>
                                    <p class="sub">Electricity bills, Water bills, etc.</p>
                                </div>
                            </div>


                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(5, 'Transport & Tolls')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M495.6 136.5H145.1c-6.2-8.2-15.2-14.1-25.6-16.2v-10.3c0-13.6-11-24.7-24.7-24.7H41.7c-13.6 0-24.7 11-24.7 24.7v265.5C7.5 376.1 0 384 0 393.7v14.8c0 10 8.1 18.2 18.2 18.2H118.3c10 0 18.2-8.1 18.2-18.2V393.7c0-9.7-7.5-17.6-17.1-18.1V203.9c10.4-2.1 19.4-8 25.6-16.2h350.6c9 0 16.4-7.3 16.4-16.4v-18.4C512 143.9 504.7 136.5 495.6 136.5zM310.7 153.6h44.1l-17.1 17.1h-44.1L310.7 153.6zM269.5 170.7h-44.1l17.1-17.1h44.1L269.5 170.7zM379 153.6h44.1l-17.1 17.1h-44.1L379 153.6zM34.1 110c0-4.2 3.4-7.6 7.6-7.6h53c4.2 0 7.6 3.4 7.6 7.6v10.3c0 0 0 0 0 0 -0.1 0-0.2 0.1-0.3 0.1 -0.5 0.1-1.1 0.2-1.6 0.4 -0.2 0.1-0.4 0.1-0.7 0.2 -0.4 0.1-0.8 0.2-1.2 0.4 -0.2 0.1-0.5 0.2-0.7 0.2 -0.4 0.1-0.8 0.3-1.1 0.4 -0.3 0.1-0.5 0.2-0.8 0.3 -0.4 0.1-0.7 0.3-1.1 0.4 -0.2 0.1-0.5 0.2-0.7 0.3 -0.4 0.2-0.7 0.3-1.1 0.5 -0.2 0.1-0.4 0.2-0.7 0.3 -0.4 0.2-0.8 0.4-1.2 0.6 -0.2 0.1-0.4 0.2-0.5 0.3 -0.6 0.3-1.1 0.6-1.7 1 -0.1 0-0.2 0.1-0.2 0.1 -0.5 0.3-0.9 0.6-1.4 0.9 -0.2 0.1-0.4 0.3-0.5 0.4 -0.3 0.2-0.7 0.5-1 0.7 -0.2 0.2-0.4 0.3-0.6 0.5 -0.3 0.2-0.6 0.5-0.9 0.7 -0.2 0.2-0.4 0.3-0.6 0.5 -0.3 0.3-0.6 0.5-0.9 0.8 -0.2 0.2-0.4 0.3-0.6 0.5 -0.3 0.3-0.6 0.5-0.9 0.8 -0.2 0.2-0.4 0.3-0.5 0.5 -0.3 0.3-0.6 0.6-0.9 1 -0.1 0.1-0.3 0.3-0.4 0.4 -0.4 0.5-0.9 1-1.3 1.5 0 0.1-0.1 0.1-0.1 0.2 -0.4 0.4-0.7 0.9-1.1 1.4 -0.1 0.2-0.3 0.4-0.4 0.5 -0.3 0.3-0.5 0.7-0.7 1 -0.1 0.2-0.3 0.4-0.4 0.6 -0.2 0.3-0.4 0.7-0.6 1 -0.1 0.2-0.3 0.5-0.4 0.7 -0.2 0.3-0.4 0.7-0.6 1 -0.1 0.2-0.3 0.5-0.4 0.7 -0.2 0.4-0.4 0.7-0.5 1.1 -0.1 0.2-0.2 0.4-0.3 0.7 -0.2 0.4-0.4 0.8-0.5 1.2 -0.1 0.2-0.2 0.4-0.3 0.6 -0.3 0.6-0.5 1.2-0.7 1.8 0 0 0 0.1 0 0.1 -0.2 0.6-0.4 1.2-0.6 1.8 -0.1 0.2-0.1 0.4-0.2 0.6 -0.1 0.4-0.2 0.8-0.4 1.3 -0.1 0.2-0.1 0.5-0.2 0.8 -0.1 0.4-0.2 0.8-0.3 1.2 -0.1 0.3-0.1 0.5-0.2 0.8 -0.1 0.4-0.1 0.8-0.2 1.2 0 0.3-0.1 0.5-0.1 0.8 -0.1 0.4-0.1 0.8-0.2 1.2 0 0.3-0.1 0.5-0.1 0.8 0 0.5-0.1 0.9-0.1 1.4 0 0.2 0 0.4 0 0.7 0 0.7-0.1 1.4-0.1 2.1s0 1.4 0.1 2.1c0 0.2 0 0.4 0 0.7 0 0.5 0.1 0.9 0.1 1.4 0 0.3 0.1 0.5 0.1 0.8 0 0.4 0.1 0.8 0.2 1.2 0 0.3 0.1 0.5 0.1 0.8 0.1 0.4 0.1 0.8 0.2 1.2 0.1 0.3 0.1 0.5 0.2 0.8 0.1 0.4 0.2 0.8 0.3 1.2 0.1 0.3 0.1 0.5 0.2 0.8 0.1 0.4 0.2 0.9 0.4 1.3 0.1 0.2 0.1 0.4 0.2 0.6 0.2 0.6 0.4 1.2 0.6 1.8 0 0 0 0.1 0 0.1 0.2 0.6 0.5 1.2 0.7 1.8 0.1 0.2 0.2 0.4 0.3 0.6 0.2 0.4 0.4 0.8 0.6 1.2 0.1 0.2 0.2 0.4 0.3 0.7 0.2 0.4 0.4 0.7 0.6 1.1 0.1 0.2 0.3 0.5 0.4 0.7 0.2 0.3 0.4 0.7 0.6 1 0.1 0.2 0.3 0.5 0.4 0.7 0.2 0.3 0.4 0.7 0.6 1 0.1 0.2 0.3 0.4 0.4 0.6 0.2 0.4 0.5 0.7 0.7 1 0.1 0.2 0.3 0.4 0.4 0.5 0.3 0.5 0.7 0.9 1.1 1.4 0 0.1 0.1 0.1 0.1 0.2 0.4 0.5 0.8 1 1.3 1.5 0.1 0.1 0.3 0.3 0.4 0.4 0.3 0.3 0.6 0.6 0.9 1 0.2 0.2 0.4 0.3 0.5 0.5 0.3 0.3 0.6 0.6 0.9 0.8 0.2 0.2 0.4 0.3 0.6 0.5 0.3 0.3 0.6 0.5 0.9 0.8 0.2 0.2 0.4 0.3 0.6 0.5 0.3 0.3 0.6 0.5 0.9 0.7 0.2 0.2 0.4 0.3 0.6 0.5 0.3 0.3 0.7 0.5 1 0.7 0.2 0.1 0.4 0.3 0.5 0.4 0.5 0.3 0.9 0.6 1.4 0.9 0.1 0 0.1 0.1 0.2 0.1 0.6 0.3 1.1 0.7 1.7 1 0.2 0.1 0.3 0.2 0.5 0.3 0.4 0.2 0.8 0.4 1.2 0.6 0.2 0.1 0.4 0.2 0.7 0.3 0.4 0.2 0.7 0.3 1.1 0.5 0.2 0.1 0.5 0.2 0.7 0.3 0.4 0.2 0.7 0.3 1.1 0.4 0.2 0.1 0.5 0.2 0.7 0.3 0.4 0.1 0.8 0.3 1.1 0.4 0.2 0.1 0.5 0.2 0.7 0.2 0.4 0.1 0.8 0.2 1.3 0.4 0.2 0.1 0.4 0.1 0.7 0.2 0.5 0.1 1.1 0.3 1.6 0.4 0.1 0 0.2 0.1 0.3 0.1 0 0 0 0 0 0v171.5H34.1V110zM119.5 408.5c0 0.6-0.5 1.1-1.1 1.1H18.2c-0.6 0-1.1-0.5-1.1-1.1V393.7c0-0.6 0.5-1.1 1.1-1.1H118.3c0.6 0 1.1 0.5 1.1 1.1V408.5zM110.9 187.7c-14.1 0-25.6-11.5-25.6-25.6 0-14.1 11.5-25.6 25.6-25.6 14.1 0 25.6 11.5 25.6 25.6C136.5 176.3 125.1 187.7 110.9 187.7zM153.6 153.6h64.7l-17.1 17.1h-47.7V153.6zM494.9 170.7h-64.7l17.1-17.1h47.7V170.7z"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">Transport & Tolls</p>
                                    <p class="sub">Toll gate, LCC, etc.</p>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(2, 'Airtime Recharge')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M458.7 181.3c-14.7 0-37 5.1-53.3 20.4V32c0-17.7-14.3-32-32-32H138.7c-17.7 0-32 14.3-32 32v128h-32c-17.7 0-32 14.3-32 32v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 17.7 14.3 32 32 32h32V480c0 17.7 14.3 32 32 32h234.7c17.7 0 32-14.3 32-32V248.6c1.7-22.8 19.3-41.9 42.7-44.8v297.5h21.3V192C469.3 186.1 464.6 181.3 458.7 181.3zM138.7 21.3h234.7C379.2 21.3 384 26.1 384 32v32H128V32C128 26.1 132.8 21.3 138.7 21.3zM64 341.3V320c0-5.9 4.8-10.7 10.7-10.7h32V352h-32C68.8 352 64 347.2 64 341.3zM64 277.3V256c0-5.9 4.8-10.7 10.7-10.7h32V288h-32C68.8 288 64 283.2 64 277.3zM64 192c0-5.9 4.8-10.7 10.7-10.7h32V224h-32C68.8 224 64 219.2 64 213.3V192zM74.7 416C68.8 416 64 411.2 64 405.3V384c0-5.9 4.8-10.7 10.7-10.7h32V416H74.7zM373.3 490.7H138.7c-5.9 0-10.7-4.8-10.7-10.7v-32h256v32C384 485.9 379.2 490.7 373.3 490.7zM384 426.7H128v-64 -64 -64 -64V85.3h256V426.7z"></path>
                                        <path d="M256 149.3c-58.9 0-106.7 47.8-106.7 106.7S197.1 362.7 256 362.7c58.9-0.1 106.6-47.8 106.7-106.7C362.7 197.1 314.9 149.3 256 149.3zM256 341.3c-47.1 0-85.3-38.2-85.3-85.3s38.2-85.3 85.3-85.3c47.1 0.1 85.3 38.2 85.3 85.3C341.3 303.1 303.1 341.3 256 341.3z"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">Airtime Recharge</p>
                                    <p class="sub">Wakanow Mobile & 9mobile Postpaid, etc.</p>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div @click="billerCategoryList(9, 'Other Payments')" class="opt">
                                    <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.2 512.2">
                                        <path d="M273.1 337.1H409.6c5.1 0 8.5-3.4 8.5-8.5v-76.8c0-5.1-3.4-8.5-8.5-8.5H273.1c-5.1 0-8.5 3.4-8.5 8.5v76.8C264.5 333.7 267.9 337.1 273.1 337.1zM281.6 260.3h119.5v59.7H281.6V260.3z"></path>
                                        <path d="M42.7 226.2h68.3c5.1 0 8.5-3.4 8.5-8.5s-3.4-8.5-8.5-8.5H42.7c-5.1 0-8.5 3.4-8.5 8.5S37.5 226.2 42.7 226.2z"></path>
                                        <path d="M145.1 226.2h68.3c5.1 0 8.5-3.4 8.5-8.5s-3.4-8.5-8.5-8.5h-68.3c-5.1 0-8.5 3.4-8.5 8.5S139.9 226.2 145.1 226.2z"></path>
                                        <path d="M42.7 260.3H153.6c5.1 0 8.5-3.4 8.5-8.5s-3.4-8.5-8.5-8.5H42.7c-5.1 0-8.5 3.4-8.5 8.5S37.5 260.3 42.7 260.3z"></path>
                                        <path d="M213.3 243.3h-25.6c-5.1 0-8.5 3.4-8.5 8.5s3.4 8.5 8.5 8.5h25.6c5.1 0 8.5-3.4 8.5-8.5S218.5 243.3 213.3 243.3z"></path>
                                        <path d="M504.3 137.5c-6-7.7-13.7-11.9-23-12.8l-20.5-2.5V98.2 81.1c0-18.8-15.4-34.1-34.1-34.1H34.1C15.4 47 0 62.4 0 81.1v17.1 68.3 187.7c0 15.4 10.4 28.5 24.5 32.7 -0.4 17.3 12.6 32.2 30.2 33.8l394.2 44.4c0.9 0 2.6 0 3.4 0 17.1 0 32.4-12.8 34.1-29l25.6-273.9C512.9 153.7 510.3 144.3 504.3 137.5zM17.1 106.7h426.7v22.2 29H17.1V106.7zM34.1 64.1h392.5c9.4 0 17.1 7.7 17.1 17.1v8.5H17.1v-8.5C17.1 71.8 24.7 64.1 34.1 64.1zM17.1 354.2v-179.2h426.7v179.2c0 9.4-7.7 17.1-17.1 17.1H35h-0.9C24.7 371.3 17.1 363.6 17.1 354.2zM494.9 158.8l-25.6 273.9c-0.9 9.4-9.4 16.2-18.8 15.4L57.2 403.7c-8.5-0.9-14.5-7.7-15.4-15.4h384.9c18.8 0 34.1-15.4 34.1-34.1V166.5v-28.2l19.6 1.7c4.3 0 8.5 2.6 11.1 6C494.1 149.4 495.8 154.5 494.9 158.8z"></path>
                                    </svg>
                                </span>
                                    </div>
                                    <p class="hed">Other Payments</p>
                                    <p class="sub">Insurance, MFBs, Wallets, etc.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="stage === 2">
                <div class="form-component">

                    <div class="card mb-4">
                        <div class="card-body">
                            <!--<div class="card-title">From Me TO Me</div>-->
                            <!--<div class="card-title">{{pageSub}}</div>-->
                            <div class="card-title">{{pageSub_}}</div>

                            <div class="card-content">
                                <form @submit.prevent="billerProductList">
                                    <div class="alert-box">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                    {{alert.message}}
                                                </ui-alert>
                                            </div>
                                        </div>
                                    </div>

                                    <!--<form>-->
                                    <div class="row">
                                        <div class="col-sm-12 form-group mb-2">
                                            <!--<accounts-select-box></accounts-select-box>-->
                                            <label>Biller*</label>
                                            <ui-select
                                                    ref="billerIdSelect"
                                                    placeholder="Select Biller ID"
                                                    type="basic"
                                                    has-search
                                                    :options="billerOptions"
                                                    v-model="billerId"
                                            ></ui-select>
                                        </div>

                                        <div class="col-sm-12">
                                            <button class="btn btn-primary btn-xnax push-right">Submit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div v-else-if="stage === 3">
                <div class="form-component">

                    <div class="card mb-4">
                        <div class="card-body">
                            <!--<div class="card-title">From Me TO Me</div>-->
                            <div class="card-title">{{pageSub2}}</div>

                            <div class="card-content">
                                <form @submit.prevent="billerValidation">
                                    <div class="alert-box">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                    {{alert.message}}
                                                </ui-alert>
                                            </div>
                                        </div>
                                    </div>

                                    <!--<form>-->
                                    <div class="row">
                                        <div class="col-md-6 form-group mb-2">
                                            <!--<accounts-select-box></accounts-select-box>-->
                                            <label>Debit Account*</label>
                                            <ui-select
                                                    ref="debitAccountSelect"
                                                    placeholder="Select Debit Account"
                                                    type="basic"
                                                    :options="dat"
                                                    error="You must select at least 1 colours"
                                                    :invalid="debitAcctTouched && debitAcct.length < 1"
                                                    @touch="debitAcctTouched = true"
                                                    v-model="debitAcct"
                                            ></ui-select>
                                        </div>

                                        <div class="col-md-6 form-group mb-2">
                                            <label for="userRef">{{userRefName}}*</label>
                                            <input type="text" class="form-control" id="userRef" name="userRef"
                                                   :placeholder="'Select '+ userRefName" v-model="userRef"
                                                   required v-validate="'required'"
                                            >
                                            <span v-show="errors.has('userRef')" class="error-span is-danger">{{ errors.first('userRef') }}</span>
                                        </div>

                                        <div class="col-md-6 form-group mb-2">
                                            <!--<accounts-select-box></accounts-select-box>-->
                                            <label>Product*</label>
                                            <ui-select
                                                    ref="billerIdSelect"
                                                    placeholder="Select Biller ID"
                                                    type="basic"
                                                    has-search
                                                    :options="productOptions"
                                                    v-model="productId"
                                            ></ui-select>
                                        </div>

                                        <div v-if="productId === ''" class="col-md-6"></div>
                                        <div v-else class="col-md-6">
                                            <div v-if="productId.value[2] === '0'" class="form-group mb-2">
                                                <label for="amount" class="form-label">Amount*</label>
                                                <div class="amount-input">
                                                    <div class="currency">
                                                        <span>&#8358;</span>
                                                    </div>

                                                    <input
                                                            type="text" id="amount" class="input"
                                                            value="" data-type="currency" placeholder="Amount" data-vv-name="Amount"
                                                            v-model="amount" name="amount" v-on:keypress="isNumber($event)" required
                                                            @change="amountOnChange(amount)"
                                                    >
                                                </div>
                                            </div>
                                        </div>


                                        <div class="col-md-12">
                                            <button class="btn btn-primary btn-xnax push-right">Submit</button>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";


    export default {
        name: "OtherBills",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return {
                stage: 1,
                pageSub: 'Other Bills',
                pageSub: 'Other Bills',
                pageSub_: '',

                billerId: '',
                productId: '',
                userRef: '',
                userRefName: '',
                debitAcct: '',
                debitAcctTouched: false,
                amount: '',

                stage1Response: '',
                stage2Response: '',
                stage3Response: '',

                billerOptions: [],
                productOptions: [],
                dat: [],


                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getUsername',
                'getDataOnLogin',
            ])
        },
        created () {
            this.popDebitAcct()
        },
        methods: {
            ...mapActions([
                'updateAppLoading',
                'updateSideBarPage',
                'updateInsideCurrentPage',
                'updateMobileDataBiller',
                'updateConfirmationPageBody',
            ]),

            backButton(){
                if (this.stage === 1){
                    this.updateInsideCurrentPage('payBills')
                }
                else if (this.stage === 2){
                    this.stage = 1;
                }
                else if (this.stage === 3){
                    this.stage = 2;
                }
            },
            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },

            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            amountOnChange(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                // _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = this.cleanAmount(_incomingAmount);
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                this.amount = answer;
            },
            cleanAmount(_amount){
                _amount = _amount.replace(/,/g, '');
                _amount = (parseFloat(_amount).toFixed(2)).toString();

                return _amount
            },


            popDebitAcct(){
                let sdat = [];
                let sample = {};

                for (let i = 0; i < this.getDataOnLogin.accountlist.length; i++){

                    if (this.getDataOnLogin.accountlist[i].account_type === 'IBANKER'){
                        // console.log('I Banker Account')
                    } else {
                        sample.label = this.getDataOnLogin.accountlist[i].accountno + " - ₦" + this.$options.filters.moneyFormat(this.getDataOnLogin.accountlist[i].availablebalance);
                        sample.value = this.getDataOnLogin.accountlist[i];

                        sdat.push(sample)

                        sample = {}
                    }
                }
                this.dat = sdat;
            },
            popBillers(){
                let popArray = this.stage1Response.result
                let sdat = [];
                let sample = {};

                for (let i = 0; i < popArray.length; i++){
                    sample.label = popArray[i].biller_name;
                    sample.value = [popArray[i].biller_id, popArray[i].biller_name, popArray[i].customerfield1];

                    sdat.push(sample)

                    sample = {}
                }
                this.billerOptions = sdat;
            },
            popProducts(){
                let popArray = this.stage2Response.result
                let sdat = [];
                let sample = {};

                for (let i = 0; i < popArray.length; i++){
                    sample.label = popArray[i].paymentitem_name + ' - ₦' + this.$options.filters.moneyFormat(popArray[i].amount);
                    sample.value = [popArray[i].paymentcode, popArray[i].paymentitem_name, popArray[i].amount];

                    sdat.push(sample)

                    sample = {}
                }
                this.productOptions = sdat;
            },


            billerCategoryList(id, _pageSub){
                // console.log('test =>', id);

                this.pageSub_ = _pageSub;

                //start app loading
                this.updateAppLoading(true);

                //  Make API call
                axios
                    .post('/billercategorylist', {
                        category_id: id
                    })
                    .then(response => {
                        //stop app loading
                        this.updateAppLoading(false);

                        let responseData = response.data;

                        if (responseData.responsecode === '00'){
                            //store the response of stage one
                            this.stage1Response = responseData;

                            // console.log('Stage 1 Response(2) =>', this.stage1Response.result);

                            // pop the biller ID select options i the next stage
                            this.popBillers()


                            //reset Notification
                            this.alert.show = false;

                            //    switch pages/stages
                            this.stage = 2
                        }else {
                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    })
                    .catch(error => {
                        //stop app loading
                        this.updateAppLoading(false);

                        // console.log(error);
                        // display error notification
                        this.showAlert(true, 'error', 'Network error please try again!');
                    })
            },
            billerProductList(){
                if(this.billerId === undefined || this.billerId === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select a Biller*')
                }
                else {
                    //start app running
                    this.updateAppLoading(true);

                    // console.log('this Biller ID (array)=>>>>>', this.billerId);

                    this.userRefName = this.billerId.value[2];

                    // console.log('this userRefName ID (array) ===>>>>>', this.userRefName);


                    //  Make API call
                    axios
                        .post('/billerproductlist', {
                            biller_id: this.billerId.value[0]
                        })
                        .then(response => {

                            //stop app loading
                            this.updateAppLoading(false);

                            let responseData = response.data;

                            if (responseData.responsecode === '00'){

                                this.stage2Response = responseData;

                                // console.log('Stage 2 Response(2) =>', this.stage2Response.result);

                                // pop the Product select options i the next stage
                                this.popProducts()

                                // set the page sub 2
                                this.pageSub2 = this.billerId.value[1];

                                //reset Notification
                                this.alert.show = false;

                                //    switch pages/stages
                                this.stage = 3
                            }else {
                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }
                        })
                        .catch(error => {
                            //stop app loading
                            this.updateAppLoading(false);

                            // console.log(error);
                            // display error notification
                            this.showAlert(true, 'error', 'Network error please try again!');
                        })
                }
            },
            billerValidation(){
                if(this.debitAcct === undefined || this.debitAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Debit Account*')
                }
                else if(this.userRef === undefined || this.userRef === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Enter' + this.userRefName)
                }
                else if(this.productId === undefined || this.productId === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select a Product*')
                }
                else {
                    // this.userRefName = this.billerId.value[2];

                    //start app running
                    this.updateAppLoading(true);

                    //  Make API call
                    axios
                        .post('/billervalidation', {
                                username: this.getUsername,
                                paymentitemcode: this.productId.value[0],
                                billercustomerid: this.userRef
                            },
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }
                            }
                        )
                        .then(response => {
                            //stop app loading
                            this.updateAppLoading(false);

                            let responseData = response.data;

                            if (responseData.responsecode === '00'){

                                this.stage3Response = responseData.Customers;

                                // console.log('Stage 3 Response(3) =>', this.stage3Response);

                                //reset Notification
                                this.alert.show = false;

                                // console.log('billerId FLAGG -->1', this.billerId)
                                // console.log('productId FLAGG -->2', this.productId)
                                // console.log('userRef FLAGG -->3', this.userRef)
                                // console.log('userRefName FLAGG -->4', this.userRefName)
                                // console.log('debitAcct FLAGG -->5', this.debitAcct)
                                // console.log('stage1Response FLAGG -->7', this.stage1Response)
                                // console.log('stage2Response FLAGG -->8', this.stage2Response)
                                // console.log('stage3Response FLAGG -->9', this.stage3Response)

                                // let amount;
                                // amount = this.productId.value[2] === '0' ? this.amount : this.productId.value[2];
                                //

                                //    prepare the post Body
                                let pastBody ={
                                    debitAcct:  this.debitAcct.value,
                                    creditBank: this.billerId.value[1],
                                    creditAccount: this.userRef,
                                    amount: this.productId.value[2] === '0' ? this.cleanAmount(this.amount) : this.productId.value[2],
                                    product: this.productId,
                                    biller: this.billerId,
                                    stage3Response: this.stage3Response[0],
                                    showNarration: false,
                                    confirmationType: 'Pay Bills',
                                    confirmationTypeSub: 'Other Bills',
                                    transactionType: 'otherBills',
                                    creditAccountName: this.stage3Response[0].fullName === '' || this.stage3Response[0].fullName === undefined ? this.userRef : this.stage3Response[0].fullName,
                                    narration:  '',
                                }



                                // Save Details in the Store for Name Enquiry
                                this.updateConfirmationPageBody(pastBody);

                                // console.log('final PAST Body', pastBody);

                                //Update the current sub component in the store
                                this.updateInsideCurrentPage('confirmation');
                            }else {
                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }
                        })
                        .catch(error => {
                            //stop app loading
                            this.updateAppLoading(false);

                            // console.log('ERRRRRORR!!!! ===>>', error)

                            // display error notification
                            this.showAlert(true, 'error', 'Network error please try again!')
                        })
                }
            },

        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>

</style>